import React, { useState } from "react";
import { API_BASE_URL } from "../Config";
import { Container, Row, Col, Form, Button, Alert } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';

function RegisterScreen() {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    name: "",
    lastname: "",
    additional_address: "",
    email: "",
    postal_code: "",
    address: "",
    number: "",
    city: "",
    country: "",
    phone: "",
    password: "",
    confirmPassword: "",
  });

  const [showError, setShowError] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showForm, setShowForm] = useState(true);
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const validatePassword = (password) => {
    const minLength = /.{8,}/;
    const hasSymbol = /[!@#$%^&*(),.?":{}|<>]/;
    const hasUppercase = /[A-Z]/;
    const hasLowercase = /[a-z]/;

    if (!minLength.test(password)) {
      return t('password_min_length');
    }
    if (!hasSymbol.test(password)) {
      return t('password_symbol');
    }
    if (!hasUppercase.test(password)) {
      return t('password_uppercase');
    }
    if (!hasLowercase.test(password)) {
      return t('password_lowercase');
    }
    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setShowError(false);
    setShowSuccess(false);

    const passwordError = validatePassword(formData.password);
    if (passwordError) {
      setErrorMessage(passwordError);
      setShowError(true);
      return;
    }

    if (formData.password !== formData.confirmPassword) {
      setErrorMessage(t('password_mismatch'));
      setShowError(true);
      return;
    }

    try {
      console.log("Enviando dados:", formData);
      const response = await fetch(`${API_BASE_URL}/api/register/`, { 
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();
      console.log("Resposta da API:", data);

      if (response.ok) {
        setShowSuccess(true);
        setShowForm(false);
      } else {
        const errorMessage = data.email ? data.email[0] : t('registration_error');
        setErrorMessage(errorMessage);
        setShowError(true);
      }
    } catch (error) {
      console.error("Erro ao enviar dados:", error);
      setErrorMessage(t('registration_error'));
      setShowError(true);
    }
  };

  return (
    <Container className="pt-4">
      <Row>
        <Col sm={12} className="m-auto">
          <h2 className="h4 mb-4">{t('register')}</h2>
        </Col>
      </Row>

      {showSuccess && (
        <Alert variant="success">
          {t('registration_success')}
        </Alert>
      )}

      {showForm && (
        <Form onSubmit={handleSubmit} className="p-4 m-auto forms">
          <Row>
            <Col md={6} sm={12}>
              <Form.Group className="mb-3" controlId="formName">
                <Form.Label>{t('name')}</Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>
            
            <Col md={6} sm={12}>
              <Form.Group className="mb-3" controlId="formLastname">
                <Form.Label>{t('lastname')}</Form.Label>
                <Form.Control
                  type="text"
                  name="lastname"
                  value={formData.lastname}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={6} sm={12}>
              <Form.Group className="mb-3" controlId="formAdditionalAddress">
                <Form.Label>{t('additional_address')}</Form.Label>
                <Form.Control
                  type="text"
                  name="additional_address"
                  value={formData.additional_address}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
            
            <Col md={6} sm={12}>
              <Form.Group className="mb-3" controlId="formEmail">
                <Form.Label>E-Mail</Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={6} sm={12}>
              <Form.Group className="mb-3" controlId="formPostalCode">
                <Form.Label>{t('postal_code')}</Form.Label>
                <Form.Control
                  type="text"
                  name="postal_code"
                  value={formData.postal_code}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>
            
            <Col md={6} sm={12}>
              <Form.Group className="mb-3" controlId="formAddress">
                <Form.Label>{t('address')}</Form.Label>
                <Form.Control
                  type="text"
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={6} sm={12}>
              <Form.Group className="mb-3" controlId="formNumber">
                <Form.Label>{t('number')}</Form.Label>
                <Form.Control
                  type="text"
                  name="number"
                  value={formData.number}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>
            
            <Col md={6} sm={12}>
              <Form.Group className="mb-3" controlId="formCity">
                <Form.Label>{t('city')}</Form.Label>
                <Form.Control
                  type="text"
                  name="city"
                  value={formData.city}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={6} sm={12}>
              <Form.Group className="mb-3" controlId="formCountry">
                <Form.Label>{t('country')}</Form.Label>
                <Form.Control
                  type="text"
                  name="country"
                  value={formData.country}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>
            
            <Col md={6} sm={12}>
              <Form.Group className="mb-3" controlId="formPhone">
                <Form.Label>{t('phone')}</Form.Label>
                <Form.Control
                  type="text"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={6} sm={12}>
              <Form.Group className="mb-3" controlId="formPassword">
                <Form.Label>{t('password')}</Form.Label>
                <Form.Control
                  type={showPassword ? "text" : "password"}
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>
            
            <Col md={6} sm={12}>
              <Form.Group className="mb-3" controlId="formConfirmPassword">
                <Form.Label>{t('confirm_password')}</Form.Label>
                <Form.Control
                  type={showPassword ? "text" : "password"}
                  name="confirmPassword"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col sm={12}>
              <Form.Group className="mb-3">
                <Form.Check
                  type="checkbox"
                  id="showPasswordCheckbox"
                  label={<label htmlFor="showPasswordCheckbox" style={{ cursor: "pointer" }}>{t('show_password')}</label>}
                  onChange={() => setShowPassword(!showPassword)}
                />
              </Form.Group>
            </Col>
          </Row>

          {showError && (
            <Alert variant="danger">
              {errorMessage}
            </Alert>
          )}
          
          <Row>
            <Col sm={12}>
              <Button
                variant="primary"
                type="submit">
                {t('submit')}
              </Button>

              <Button
                variant="primary"
                className="ms-2"
                title={t('register')}
                as={Link}
                to="/login"
              >
                {t('login')}
              </Button>
            </Col>
          </Row>                  
        </Form>
      )}
    </Container>
  );
}

export default RegisterScreen;
